import { render, staticRenderFns } from "./JourneysList.vue?vue&type=template&id=457394c8"
import script from "./JourneysList.vue?vue&type=script&lang=js"
export * from "./JourneysList.vue?vue&type=script&lang=js"
import style0 from "./JourneysList.vue?vue&type=style&index=0&id=457394c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports